const app = {
    state: {
        device: 'desktop',
        burgerMenu: false,
        heroTitle: '',
        heroTitleTag: 'h1',
        heroImage: '',
        heroSocialList: null,
        heroBubble: '',
        app: window.App,
        lang: window.App.page.lang
    },
    mutations: {
        ToggleDevice: (state, device) => {
            state.device = device
        },
        SetHeroTitle: (state, heroTitle) => {
            state.heroTitle = heroTitle
        },
        SetHeroTitleTag: (state, size) => {
            state.heroTitleTag = size
        },
        SetHeroImage: (state, heroImage) => {
            state.heroImage = heroImage
        },
        SetHeroSocialList: (state, heroSocialList) => {
            state.heroSocialList = heroSocialList
        },
        SetHeroBubble: (state, heroBubble) => {
            state.heroBubble = heroBubble
        },
        ToggleBurgerMenu: (state) => {
            state.burgerMenu = !state.burgerMenu
        },
    },
    actions: {
        ToggleDevice ({ commit }, device) {
            commit('ToggleDevice', device)
        },
        ToggleBurgerMenuAction ({ commit }) {
            commit('ToggleBurgerMenu')
        },
        SetHeroTitle ({ commit }, title) {
            commit('SetHeroTitle', title)
        },
        SetHeroTitleTag ({ commit }, size) {
            commit('SetHeroTitleTag', size)
        },
        SetHeroImage ({ commit }, image) {
            commit('SetHeroImage', image)
        },
        SetHeroSocialList: ({ commit }, heroSocialList) => {
            commit('SetHeroSocialList', heroSocialList)
        },
        SetHeroBubble: ({ commit }, heroBubble) => {
            commit('SetHeroBubble', heroBubble)
        },
    }
}

export default app
